"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// https://docs.adyen.com/online-payments/api-only/downloading-logos

/** @optimized using svgo:^3.0.2 */
export const VisaRectangle = createSVGIcon(
  <>
    <path
      d="M3 .25h34A2.75 2.75 0 0 1 39.75 3v20A2.75 2.75 0 0 1 37 25.75H3A2.75 2.75 0 0 1 .25 23V3A2.75 2.75 0 0 1 3 .25Z"
      fill="#293381"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.518 19.1h-2.57c-.1-.41-.2-.8-.26-1.2a.46.46 0 0 0-.328-.461.4.4 0 0 0-.192-.01c-.96.03-1.91 0-2.87.03a.76.76 0 0 0-.5.4c-.19.4-.34.82-.48 1.24h-2.91c.08-.22.14-.42.22-.6l3.89-9.52a1.5 1.5 0 0 1 1.58-1.08c.7.03 1.4 0 2.14 0zM1.398 7.99c.16-.04.33-.07.49-.09h4.19c.36-.05.73.05 1.02.3.29.23.46.59.49.97l1.09 5.88.09.4.26-.54c.84-2.16 1.68-4.32 2.5-6.48.14-.38.3-.56.73-.54.78.04 1.56.01 2.44.01l-1.25 3.08c-1.04 2.54-2.1 5.08-3.12 7.63a.7.7 0 0 1-.8.52c-.78-.03-1.56 0-2.4 0l-.96-3.74c-.43-1.68-.87-3.36-1.26-5.05a1.74 1.74 0 0 0-1.17-1.38c-.77-.28-1.55-.53-2.32-.8L1.398 8zm25.59.25-.46 2.2c-.63-.17-1.26-.3-1.91-.38a3.64 3.64 0 0 0-1.56.22c-.7.28-.74.95-.14 1.41.36.26.74.49 1.13.7l.84.49a3.18 3.18 0 0 1 1.59 2.77c0 1.16-.6 2.23-1.59 2.78a6.8 6.8 0 0 1-4.6.77 8 8 0 0 1-1.5-.36.59.59 0 0 1-.3-.47c.1-.68.27-1.34.4-1.95.87.19 1.71.42 2.57.53a3 3 0 0 0 1.39-.2.88.88 0 0 0 .68-.77.9.9 0 0 0-.46-.92c-.29-.2-.58-.38-.89-.54-.49-.26-.96-.56-1.42-.88a2.94 2.94 0 0 1-.33-4.46 4.5 4.5 0 0 1 2.45-1.32 6.97 6.97 0 0 1 4.11.38M16.428 19.1h-2.83l2.34-11.16h2.81zm15.87-7.96.82 4h-2.38l1.43-4.03.14.03z"
      fill="#fff"
    />
    <rect
      x=".25"
      y=".25"
      width="39.5"
      height="25.5"
      rx="2.75"
      stroke="#AAA"
      strokeWidth=".5"
    />
  </>,
  "VisaRectangle",
  {
    viewBox: "0 0 40 26",
    titleAccess: "Visa Icon",
    fill: "none",
  }
);
